import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import React from 'react';

import { Text } from '../../../../../../../react-components/Text';

interface StopReportContainerProps {
  textId?: string;
  text?: string;
  childrenImage?: React.ReactNode;
  showMandatory?: boolean;
  isMandatory?: boolean;
  hasValue?: boolean;
}

export const StopReportContainer = ({
  textId,
  text,
  childrenImage,
  isMandatory,
  showMandatory,
  hasValue,
  children,
}: React.PropsWithChildren<StopReportContainerProps>) => {
  return (
    <>
      <Grid item style={{ display: `contents`, backgroundColor: RoutalPalette.white, width: `100%` }}>
        <Grid item style={{ display: `flex`, flexDirection: `row`, alignItems: `center` }}>
          {childrenImage ? (
            <Grid style={{ height: `15px`, width: `20px`, marginRight: `5px` }}>{childrenImage}</Grid>
          ) : null}

          {textId ? (
            <Text style={{ fontSize: `12px` }} variant="label" intlId={textId} />
          ) : (
            <Text style={{ fontSize: `12px` }} variant="label">
              {text}
            </Text>
          )}
          {isMandatory && (
            <Text style={{ fontSize: `12px`, marginLeft: `4px`, color: RoutalPalette.error.medium }} variant="label">
              *
            </Text>
          )}
        </Grid>
        <VSpacer small />
        {children}
      </Grid>
      <Grid
        style={{
          height: isMandatory && !hasValue && showMandatory ? 24 : 0,
          transition: `height 0.3s, opacity 0.3s`,
          opacity: isMandatory && !hasValue && showMandatory ? 1 : 0,
        }}
      >
        <VSpacer small />
        {isMandatory && !hasValue && showMandatory && (
          <>
            <Text
              variant="label"
              intlId={`drivers.stop.report.mandatory_field`}
              style={{ color: RoutalPalette.error.medium }}
            />
            <VSpacer small />
          </>
        )}
      </Grid>
    </>
  );
};
